import loadView3 from "./loadView3";

const view3 = {
  loadView3,
};

export default view3;
